import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width={26}
      height={26}
      rx={4}
      fill="url(#paint0_linear_15401_16333)"
    />
    <path
      d="M6.81842 4.3335H16.7562C18.4125 4.3335 19.2406 5.16164 19.2406 6.81793V16.7557C19.2406 18.412 18.4125 19.2401 16.7562 19.2401H6.81842C5.16213 19.2401 4.33398 18.412 4.33398 16.7557V6.81793C4.33398 5.16164 5.16213 4.3335 6.81842 4.3335Z"
      fill="#D9D9D9"
    />
    <path
      d="M6.81842 4.3335H16.7562C18.4125 4.3335 19.2406 5.16164 19.2406 6.81793V16.7557C19.2406 18.412 18.4125 19.2401 16.7562 19.2401H6.81842C5.16213 19.2401 4.33398 18.412 4.33398 16.7557V6.81793C4.33398 5.16164 5.16213 4.3335 6.81842 4.3335Z"
      fill="url(#paint1_linear_15401_16333)"
    />
    <g filter="url(#filter0_b_15401_16333)">
      <path
        d="M13.5197 6.06689H18.4886C19.1475 6.06689 19.7824 6.32561 20.2484 6.79153C20.7143 7.25746 20.973 7.89242 20.973 8.55133V18.4891C20.973 19.148 20.7113 19.7799 20.2454 20.2458C19.7794 20.7118 19.1475 20.9735 18.4886 20.9735H8.55084C7.89193 20.9735 7.26 20.7118 6.79408 20.2458C6.32816 19.7799 6.06641 19.148 6.06641 18.4891V13.5202C6.06641 9.40412 9.40363 6.06689 13.5197 6.06689Z"
        fill="url(#paint2_linear_15401_16333)"
      />
      <path
        d="M13.5197 6.06689H18.4886C19.1475 6.06689 19.7824 6.32561 20.2484 6.79153C20.7143 7.25746 20.973 7.89242 20.973 8.55133V18.4891C20.973 19.148 20.7113 19.7799 20.2454 20.2458C19.7794 20.7118 19.1475 20.9735 18.4886 20.9735H8.55084C7.89193 20.9735 7.26 20.7118 6.79408 20.2458C6.32816 19.7799 6.06641 19.148 6.06641 18.4891V13.5202C6.06641 9.40412 9.40363 6.06689 13.5197 6.06689Z"
        fill="url(#paint3_linear_15401_16333)"
      />
      <path
        d="M13.5197 6.12356H18.4886C19.1327 6.12356 19.7532 6.37648 20.2083 6.8316C20.6634 7.28672 20.9164 7.9072 20.9164 8.55133V18.4891C20.9164 19.133 20.6606 19.7505 20.2053 20.2058C19.75 20.6611 19.1325 20.9169 18.4886 20.9169H8.55084C7.90696 20.9169 7.28945 20.6611 6.83415 20.2058C6.37886 19.7505 6.12307 19.133 6.12307 18.4891V13.5202C6.12307 9.43541 9.43492 6.12356 13.5197 6.12356Z"
        stroke="white"
        strokeWidth={0.113333}
      />
    </g>
    <path
      d="M9.53516 15.6862C9.53516 16.3068 9.97344 16.902 10.7536 17.3408C11.5337 17.7797 12.5919 18.0262 13.6952 18.0262C14.7985 18.0262 15.8566 17.7797 16.6367 17.3408C17.4169 16.902 17.8552 16.3068 17.8552 15.6862C17.8552 15.0656 17.4169 14.4704 16.6367 14.0316C15.8566 13.5927 14.7985 13.3462 13.6952 13.3462C12.5919 13.3462 11.5337 13.5927 10.7536 14.0316C9.97344 14.4704 9.53516 15.0656 9.53516 15.6862Z"
      fill="#76CEFF"
    />
    <path
      d="M11.0938 11.267C11.0938 11.9566 11.3677 12.6179 11.8553 13.1055C12.3429 13.5931 13.0042 13.867 13.6937 13.867C14.3833 13.867 15.0446 13.5931 15.5322 13.1055C16.0198 12.6179 16.2937 11.9566 16.2937 11.267C16.2937 10.5774 16.0198 9.91611 15.5322 9.42851C15.0446 8.94092 14.3833 8.66699 13.6937 8.66699C13.0042 8.66699 12.3429 8.94092 11.8553 9.42851C11.3677 9.91611 11.0938 10.5774 11.0938 11.267Z"
      fill="url(#paint4_linear_15401_16333)"
    />
    <path
      d="M11.0627 11.267C11.0627 11.9648 11.3399 12.634 11.8333 13.1274C12.3267 13.6208 12.996 13.898 13.6937 13.898C14.3915 13.898 15.0608 13.6208 15.5542 13.1274C16.0476 12.634 16.3248 11.9648 16.3248 11.267C16.3248 10.5692 16.0476 9.89999 15.5542 9.40657C15.0608 8.91316 14.3915 8.63596 13.6937 8.63596C12.996 8.63596 12.3267 8.91316 11.8333 9.40657C11.3399 9.89999 11.0627 10.5692 11.0627 11.267Z"
      stroke="white"
      strokeOpacity={0.51}
      strokeWidth={0.0620562}
    />
    <path
      d="M12.9142 11.7866C12.7707 11.7866 12.6506 11.9031 12.6859 12.0425C12.7427 12.2669 12.8726 12.4659 13.0553 12.6081C13.2379 12.7503 13.4627 12.8276 13.6942 12.8276C13.9257 12.8276 14.1505 12.7503 14.3332 12.6081C14.5158 12.4659 14.6458 12.2669 14.7025 12.0425C14.7378 11.9031 14.6177 11.7866 14.4742 11.7866H12.9142Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_b_15401_16333"
        x={4.28674}
        y={4.28723}
        width={18.4656}
        height={18.4661}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={0.889831} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_15401_16333"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_15401_16333"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_15401_16333"
        x1={31.5}
        y1={33.5}
        x2={-0.500001}
        y2={-2.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1C77FF" />
        <stop offset={1} stopColor="#44C7FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_15401_16333"
        x1={11.9169}
        y1={4.3335}
        x2={11.9169}
        y2={19.2401}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6AC9FF" />
        <stop offset={1} stopColor="#73E2F1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_15401_16333"
        x1={16.6078}
        y1={26.4942}
        x2={4.45409}
        y2={8.93756}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.26537} stopColor="#FFFEFD" stopOpacity={0} />
        <stop offset={0.920537} stopColor="#FFFEFD" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_15401_16333"
        x1={8.39767}
        y1={7.12777}
        x2={17.8028}
        y2={17.0454}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFFEFD" stopOpacity={0} />
        <stop offset={1} stopColor="#FFFEFD" stopOpacity={0.78} />
      </linearGradient>
      <linearGradient
        id="paint4_linear_15401_16333"
        x1={13.6937}
        y1={8.66699}
        x2={13.6937}
        y2={13.867}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4386FE" />
        <stop offset={1} stopColor="#84E1FF" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgComponent;
